import {UserI} from '../global_state/state/UserState'

const WP_Scripts = (param = 0) => {
    // console.log("RUN WP_Scripts: " + param);
    
    // 3boxes on the HP

    // TODO: allow not logged user  
    let logged = false 
    if (('xf_active_user' in sessionStorage)){
        let xf_user = JSON.parse(sessionStorage.getItem('xf_active_user') || "") as UserI
        logged = xf_user?.client_id ? true : false
    }
    

    let header_elements = document.getElementsByClassName('xplore_react_reservations_header') 
    if (header_elements.length == 0) {
         return
    }
    let lang = header_elements[0].getAttribute('lang') || "CZ"
    
    // HP Page Boxes
    // hp-box-timetables-reservations
    Hp_Box_Timetables_Reservations(logged, lang);
    
    // hp-box-eshop
    // hp-box-eshop-price
    HP_Box_Eshop(logged, lang);

    // hp-box-account
    HP_Box_Account(logged, lang);

    // Price Page
    // prices_eshop_button
    Prices_Eshop_Button(logged, lang);

    // Menu Links 
    // menu_link_timetables_reservations
    Menu_Link_Timetables_reservations(logged, lang);

    // menu_link_eshop_price
    Menu_Link_Eshop_Price(logged, lang);
}
const Menu_Link_Eshop_Price = (logged: boolean, lang:string) => {
    if (!logged) {
        return 
    }

    let menu_links = document.getElementsByClassName("menu_link_eshop_price");


    for (let index = 0; index < menu_links.length; index++) {
        const element = menu_links[index];
        let link_obj: HTMLAnchorElement | Element | null = null
        if (element.nodeName == 'A') {
            link_obj = element
        }

        if (element.nodeName == 'LI') {
            link_obj = element.querySelector('a')
        }

        let link = new URL( link_obj?.getAttribute('href') || "");
        let xf_page = 'eshop';

        
        let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'
        link.pathname = wp_page
        link.searchParams.append('xf_page', xf_page)
    
        link_obj?.setAttribute('href', link.toString())


    }
}

const Menu_Link_Timetables_reservations = (logged: boolean, lang:string) => {
    if (!logged) {
        return 
    }
    let menu_links = document.getElementsByClassName("menu_link_timetables_reservations");
    for (let index = 0; index < menu_links.length; index++) {
        const element = menu_links[index];
        // console.log(element);
        // console.log(element.nodeName);
        
        let link_obj: HTMLAnchorElement | Element | null = null

        if (element.nodeName == 'A') {
            link_obj = element
        }

        if (element.nodeName == 'LI') {
            link_obj = element.querySelector('a')
        }

        // console.log(link_obj);
        // console.log(link_obj?.getAttribute('href'));
        
        let link = new URL( link_obj?.getAttribute('href') || "");
        // console.log(link);
        
        let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'
        link.pathname = wp_page
        
        let xf_page = 'reservations';
        link.searchParams.append('xf_page', xf_page)

        link_obj?.setAttribute('href', link.toString())


    }
}
const Prices_Eshop_Button = (logged: boolean, lang:string) => {
    let button = document.getElementById("prices_eshop_button");
    if (button == null) {
        return 
    }

    let link_obj = button.querySelector('div.linkarea')

    let link = new URL( window.location.href );

    let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'
    link.pathname = wp_page

    let xf_page = 'user_profile';

    if (logged) {
        xf_page = 'eshop'
    }
    
    link.searchParams.append('xf_page', xf_page)

    link_obj?.setAttribute('data-href', link.toString())

}
const HP_Box_Account = (logged:boolean, lang:string) => {
    let hp_box_a = document.getElementById("hp-box-account");
    if (hp_box_a == null) {
        return 
    }

    let link_obj = hp_box_a.querySelector('div.linkarea')
    let link = new URL( window.location.href );

    let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'
    link.pathname = wp_page

    let xf_page = 'user_profile';
    link.searchParams.append('xf_page', xf_page)

    link_obj?.setAttribute('data-href', link.toString())
}
const HP_Box_Eshop = (logged:boolean, lang: string) => {
    if (!logged) {
        return 
    }

    let hp_box_e = document.getElementById("hp-box-eshop-price");
    if (hp_box_e == null) {
        return 
    }
        let link_obj = hp_box_e.querySelector('div.linkarea')
    let link = new URL( link_obj?.getAttribute('data-href') || window.location.href );

    let xf_page = 'eshop';


    let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'
    link.pathname = wp_page

    link.searchParams.append('xf_page', xf_page)
    link_obj?.setAttribute('data-href', link.toString())
    
}
const Hp_Box_Timetables_Reservations = (logged:boolean, lang: string) => {
    if (!logged) {
        return 
    }

    let hp_box_tr = document.getElementById("hp-box-timetables-reservations"); 
    if (hp_box_tr == null ) {
        return 
    } 

    let link_obj = hp_box_tr.querySelector('div.linkarea')
    let link = new URL( link_obj?.getAttribute('data-href') || "");
    
    let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'
    link.pathname = wp_page
    
    let xf_page = 'reservations';
    link.searchParams.append('xf_page', xf_page)

    link_obj?.setAttribute('data-href', link.toString())
}

export default WP_Scripts